"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var PMSApi = /** @class */ (function (_super) {
    __extends(PMSApi, _super);
    function PMSApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This endpoint acknowledges an async request, marking it as being received by the relay.
     * Acknowledge an async request
     */
    PMSApi.prototype.actionAcknowledgeAsyncRequestRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.asyncRequestId === null || requestParameters.asyncRequestId === undefined) {
                            throw new runtime.RequiredError('asyncRequestId', 'Required parameter requestParameters.asyncRequestId was null or undefined when calling actionAcknowledgeAsyncRequest.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/pms/async-requests/{asyncRequestId}/acknowledgement".replace("{" + "asyncRequestId" + "}", encodeURIComponent(String(requestParameters.asyncRequestId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * This endpoint acknowledges an async request, marking it as being received by the relay.
     * Acknowledge an async request
     */
    PMSApi.prototype.actionAcknowledgeAsyncRequest = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionAcknowledgeAsyncRequestRaw(requestParameters)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This endpoint searches a PMS for folios that match the given parameters. A \'folio\' represents a chargeable entity in the PMS, which may be a guest, a room or another related concept.
     * Search for folios in a PMS
     */
    PMSApi.prototype.actionPmsFolioSearchRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.query === null || requestParameters.query === undefined) {
                            throw new runtime.RequiredError('query', 'Required parameter requestParameters.query was null or undefined when calling actionPmsFolioSearch.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.query !== undefined) {
                            queryParameters['query'] = requestParameters.query;
                        }
                        if (requestParameters.queryType !== undefined) {
                            queryParameters['query_type'] = requestParameters.queryType;
                        }
                        if (requestParameters.integrationConfigId !== undefined) {
                            queryParameters['integration_config_id'] = requestParameters.integrationConfigId;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/pms/folio-search",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.FolioSearchResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint searches a PMS for folios that match the given parameters. A \'folio\' represents a chargeable entity in the PMS, which may be a guest, a room or another related concept.
     * Search for folios in a PMS
     */
    PMSApi.prototype.actionPmsFolioSearch = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionPmsFolioSearchRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint sets the response of an async request.
     * Set the response of an async request
     */
    PMSApi.prototype.actionSetAsyncRequestResponseRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.asyncRequestId === null || requestParameters.asyncRequestId === undefined) {
                            throw new runtime.RequiredError('asyncRequestId', 'Required parameter requestParameters.asyncRequestId was null or undefined when calling actionSetAsyncRequestResponse.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/shop/pms/async-requests/{asyncRequestId}/response".replace("{" + "asyncRequestId" + "}", encodeURIComponent(String(requestParameters.asyncRequestId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.SetResponseForAsyncRequestToJSON(requestParameters.setResponseForAsyncRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.SetResponseForAsyncRequestResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint sets the response of an async request.
     * Set the response of an async request
     */
    PMSApi.prototype.actionSetAsyncRequestResponse = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionSetAsyncRequestResponseRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint fetches all async requests belonging to a particular pms integration that have not been processed yet.
     * Get all unprocessed async requests
     */
    PMSApi.prototype.getAsyncRequestsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.integration === null || requestParameters.integration === undefined) {
                            throw new runtime.RequiredError('integration', 'Required parameter requestParameters.integration was null or undefined when calling getAsyncRequests.');
                        }
                        queryParameters = {};
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.integration !== undefined) {
                            queryParameters['integration'] = requestParameters.integration;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/pms/async-requests",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.AsyncRequestsResponseFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint fetches all async requests belonging to a particular pms integration that have not been processed yet.
     * Get all unprocessed async requests
     */
    PMSApi.prototype.getAsyncRequests = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAsyncRequestsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return PMSApi;
}(runtime.BaseAPI));
exports.PMSApi = PMSApi;
/**
    * @export
    * @enum {string}
    */
var ActionPmsFolioSearchQueryTypeEnum;
(function (ActionPmsFolioSearchQueryTypeEnum) {
    ActionPmsFolioSearchQueryTypeEnum["Room"] = "room";
})(ActionPmsFolioSearchQueryTypeEnum = exports.ActionPmsFolioSearchQueryTypeEnum || (exports.ActionPmsFolioSearchQueryTypeEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetAsyncRequestsIntegrationEnum;
(function (GetAsyncRequestsIntegrationEnum) {
    GetAsyncRequestsIntegrationEnum["OperaFias"] = "opera-fias";
})(GetAsyncRequestsIntegrationEnum = exports.GetAsyncRequestsIntegrationEnum || (exports.GetAsyncRequestsIntegrationEnum = {}));
